import React from 'react';
import { motion } from 'framer-motion';
export function Button({
  children,
  onClick,
  className = ''
}: {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`bg-brand-terracotta text-white font-bold py-4 px-8 rounded-full shadow-lg hover:bg-brand-terracottaHover transition-colors text-lg md:text-xl w-full md:w-auto ${className}`} data-id="element-22">
      {children}
    </motion.button>;
}